<template lang="pug">
#heatmap_os_sp
  table.table
    tbody
      tr
        th Android
        td {{ android }} %
      tr
        th iOS
        td {{ ios }} %


</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: {
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    return {
    }
  },
  computed: {
    android() {
      return this.$store.state[this.state_name].os_data.android;
    },
    ios(){
      return this.$store.state[this.state_name].os_data.ios;
    }
  }
}
</script>
